export const CLICK_VS_DRAG_PX = 3;
export const TARGET_HOVER_CURSOR = "pointer";
